// 메인 게임 초기화 - 리팩토링됨
let game;

// webpack 빌드 시 모듈 import 및 전역 등록
// webpack은 entry point에서 import된 모듈만 번들에 포함하므로,
// 사용되는 모든 클래스를 명시적으로 import하여 번들에 포함시키고 전역에 등록
import Utils from "./utils/Utils.js";
import Game from "./Game.js";

// Game.js에서 사용하는 클래스들 import 및 전역 등록
import GameStateManager from "./core/GameStateManager.js";
import GameEventManager from "./core/GameEventManager.js";
import GameCoordinator from "./core/GameCoordinator.js";
import GameInitializer from "./core/GameInitializer.js";
import GameLoop from "./core/GameLoop.js";
import Debug from "./debug/Debug.js";

// GameInitializer.js에서 사용하는 클래스들 import 및 전역 등록
import ThreeSetup from "./core/ThreeSetup.js";
import SystemsInitializer from "./core/SystemsInitializer.js";
import EntitiesInitializer from "./core/EntitiesInitializer.js";
import CollisionManager from "./managers/CollisionManager.js";

// Config 파일들 import 및 전역 등록
import GameConfig from "./config/GameConfig.js";
import PlayerConfig from "./config/PlayerConfig.js";
import EnemyConfig from "./config/EnemyConfig.js";
import EnemySpawnConfig from "./config/EnemySpawnConfig.js";
import ItemConfig from "./config/ItemConfig.js";
import CompanionsConfig from "./config/CompanionsConfig.js";
import UpgradeConfig from "./config/UpgradeConfig.js";

// Systems 클래스들 import 및 전역 등록
import InputHandler from "./systems/InputHandler.js";
import CameraController from "./systems/CameraController.js";
import SpawnScheduler from "./systems/SpawnScheduler.js";
import EnemyModelCache from "./systems/EnemyModelCache.js";
import CompanionModelCache from "./systems/CompanionModelCache.js";

// Managers 클래스들 import 및 전역 등록
import UIManager from "./managers/UIManager.js";
import UpgradeManager from "./managers/UpgradeManager.js";
import ItemManager from "./managers/ItemManager.js";
import EnemySpawnManager from "./managers/EnemySpawnManager.js";
import CompanionManager from "./managers/CompanionManager.js";
import SceneManager from "./managers/SceneManager.js";

// Entities 클래스들 import 및 전역 등록
import Entity from "./entities/Entity.js";
import Party from "./entities/Party.js";
import Player from "./entities/Player.js";
import Enemy from "./entities/Enemy.js";
import Companion from "./entities/Companion.js";
import WarriorEnemy from "./entities/WarriorEnemy.js";
import MageCompanion from "./entities/MageCompanion.js";
import RogueCompanion from "./entities/RogueCompanion.js";
import BarbarianCompanion from "./entities/BarbarianCompanion.js";

// Item 클래스들 import 및 전역 등록
import Item from "./entities/Item.js";
import Diamond from "./items/Diamond.js";
import Bomb from "./items/Bomb.js";
import Heart from "./items/Heart.js";
import Magnet from "./items/Magnet.js";
import Star from "./items/Star.js";

// UI 클래스들 import 및 전역 등록
import HealthBar from "./ui/HealthBar.js";
import DamageNumber from "./ui/DamageNumber.js";

// Utils 클래스들 import 및 전역 등록
import CollisionUtils from "./utils/CollisionUtils.js";
import EffectUtils from "./utils/EffectUtils.js";
import MathUtils from "./utils/MathUtils.js";
import VectorUtils from "./utils/VectorUtils.js";

// 전역 변수로 등록하여 다른 스크립트에서도 접근 가능하도록 보장
window.Utils = Utils;
window.Game = Game;
window.GameStateManager = GameStateManager;
window.GameEventManager = GameEventManager;
window.GameCoordinator = GameCoordinator;
window.GameInitializer = GameInitializer;
window.GameLoop = GameLoop;
window.Debug = Debug;
window.ThreeSetup = ThreeSetup;
window.SystemsInitializer = SystemsInitializer;
window.EntitiesInitializer = EntitiesInitializer;
window.CollisionManager = CollisionManager;
// 한국어 주석: 모델 캐시 클래스 전역 등록 및 인스턴스 보장
window.EnemyModelCache = EnemyModelCache;
window.CompanionModelCache = CompanionModelCache;
if (!window.enemyModelCache) {
  window.enemyModelCache = new EnemyModelCache();
}
if (!window.companionModelCache) {
  window.companionModelCache = new CompanionModelCache();
}

// Config 전역 등록
window.GameConfig = GameConfig;
window.PlayerConfig = PlayerConfig;
window.EnemyConfig = EnemyConfig;
window.EnemySpawnConfig = EnemySpawnConfig;
window.ItemConfig = ItemConfig;
window.CompanionsConfig = CompanionsConfig;
window.UpgradeConfig = UpgradeConfig;

// Systems 전역 등록
window.InputHandler = InputHandler;
window.CameraController = CameraController;
window.SpawnScheduler = SpawnScheduler;

// Managers 전역 등록
window.UIManager = UIManager;
window.UpgradeManager = UpgradeManager;
window.ItemManager = ItemManager;
window.EnemySpawnManager = EnemySpawnManager;
window.CompanionManager = CompanionManager;
window.SceneManager = SceneManager;

// Entities 전역 등록
window.Entity = Entity;
window.Party = Party;
window.Player = Player;
window.Enemy = Enemy;
window.Companion = Companion;
window.WarriorEnemy = WarriorEnemy;
window.MageCompanion = MageCompanion;
window.RogueCompanion = RogueCompanion;
window.BarbarianCompanion = BarbarianCompanion;

// Item 전역 등록
window.Item = Item;
window.Diamond = Diamond;
window.Bomb = Bomb;
window.Heart = Heart;
window.Magnet = Magnet;
window.Star = Star;

// UI 전역 등록
window.HealthBar = HealthBar;
window.DamageNumber = DamageNumber;

// Utils 전역 등록
window.CollisionUtils = CollisionUtils;
window.EffectUtils = EffectUtils;
window.MathUtils = MathUtils;
window.VectorUtils = VectorUtils;

// 한국어 주석: UI 로그 출력 헬퍼 (토글 확인 후에만 출력)
function uiLog(message, level = "info") {
  try {
    const isUiLogEnabled =
      window.GameConfig &&
      window.GameConfig.DEBUG &&
      window.GameConfig.DEBUG.UI_LOG_ENABLED === true;
    if (isUiLogEnabled && typeof window.simpleLog === "function") {
      window.simpleLog(message, level);
    }
  } catch (e) {}
}

// 로드 확인 로그
uiLog("main.js: Utils와 Game을 전역에 등록 완료", "info");

// 로딩 화면 업데이트 헬퍼 함수 (전역에서 접근 가능하도록 window에 등록)
window.updateLoadingProgress = function (progress, message) {
  const loadingText = document.getElementById("loadingText");
  const loadingBarFill = document.getElementById("loadingBarFill");

  if (loadingText) loadingText.textContent = message;
  if (loadingBarFill) loadingBarFill.style.width = progress + "%";
};

// 로딩 화면 숨기기
function hideLoadingScreen() {
  const loadingScreen = document.getElementById("loadingScreen");
  if (loadingScreen) {
    loadingScreen.classList.add("fade-out");
    // 애니메이션 완료 후 완전히 제거
    setTimeout(() => {
      loadingScreen.style.display = "none";
    }, 500);
  }
}

// 스크립트 로드 상태 확인 함수
function checkScriptLoadStatus() {
  const scripts = document.querySelectorAll("script[src]");
  const scriptStatus = [];
  const criticalScripts = ["src/utils/Utils.js", "src/Game.js"];

  scripts.forEach((script) => {
    const src = script.src || script.getAttribute("src");
    if (src && src.includes("src/")) {
      const fileName = src.split("/").pop();
      const isCritical = criticalScripts.some((critical) =>
        src.includes(critical)
      );
      scriptStatus.push({
        src: src,
        fileName: fileName,
        loaded:
          script.readyState === "complete" || script.readyState === "loaded",
        isCritical: isCritical,
      });
    }
  });

  return scriptStatus;
}

// Utils와 Game 클래스가 로드될 때까지 기다리는 함수
async function waitForScripts() {
  const maxWaitTime = 15000; // 최대 15초 대기 (모바일 네트워크 고려)
  const checkInterval = 100; // 100ms마다 확인
  let elapsed = 0;

  // 현재 대기 중임을 로그에 표시
  uiLog("스크립트 로드 대기 중... (최대 " + maxWaitTime / 1000 + "초)");

  while (elapsed < maxWaitTime) {
    // webpack 빌드에서는 window.Utils와 window.Game을 확인
    // (번들 내에서는 Utils와 Game이 직접 접근 불가)
    if (
      typeof window.Utils !== "undefined" &&
      typeof window.Game !== "undefined"
    ) {
      uiLog("필수 클래스 로드 완료! (" + elapsed + "ms 경과)");
      return true;
    }

    // 중간 로그 (3초마다)
    if (elapsed > 0 && elapsed % 3000 === 0) {
      const utilsStatus =
        typeof window.Utils !== "undefined" ? "로드됨" : "로드안됨";
      const gameStatus =
        typeof window.Game !== "undefined" ? "로드됨" : "로드안됨";
      uiLog(
        `대기 중... (${
          elapsed / 1000
        }초 경과) - Utils: ${utilsStatus}, Game: ${gameStatus}`,
        "info"
      );
    }

    await new Promise((resolve) => setTimeout(resolve, checkInterval));
    elapsed += checkInterval;
  }

  // 타임아웃 시 상세 정보 로깅
  if (true) {
    uiLog(
      "타임아웃: Utils=" +
        (typeof window.Utils !== "undefined" ? "로드됨" : "로드안됨") +
        ", Game=" +
        (typeof window.Game !== "undefined" ? "로드됨" : "로드안됨"),
      "error"
    );
    uiLog(
      `window.Utils=${
        typeof window.Utils !== "undefined" ? "존재함" : "없음"
      }, window.Game=${typeof window.Game !== "undefined" ? "존재함" : "없음"}`,
      "error"
    );

    // 스크립트 로드 상태 확인
    const scriptStatus = checkScriptLoadStatus();
    if (scriptStatus.length > 0) {
      uiLog("=== 스크립트 로드 상태 상세 ===", "info");

      // 핵심 스크립트 먼저 출력
      const criticalScripts = scriptStatus.filter((s) => s.isCritical);
      if (criticalScripts.length > 0) {
        uiLog("핵심 스크립트:", "info");
        criticalScripts.forEach((status) => {
          uiLog(
            `  [${status.loaded ? "✓" : "✗"}] ${status.fileName}: ${
              status.loaded ? "로드됨" : "로드안됨"
            }`,
            status.loaded ? "info" : "error"
          );
        });
      }

      // 나머지 스크립트 샘플
      const otherScripts = scriptStatus
        .filter((s) => !s.isCritical)
        .slice(0, 5);
      if (otherScripts.length > 0) {
        uiLog("기타 스크립트 샘플:", "info");
        otherScripts.forEach((status) => {
          uiLog(
            `  [${status.loaded ? "✓" : "✗"}] ${status.fileName}: ${
              status.loaded ? "로드됨" : "로드안됨"
            }`,
            "info"
          );
        });
      }
    } else {
      uiLog("스크립트 태그를 찾을 수 없습니다!", "error");
    }
  }

  return false;
}

// 게임 초기화 함수
async function initializeGame() {
  try {
    window.updateLoadingProgress(5, "스크립트 로딩 확인 중...");

    // bundle.js 로드 확인 및 전역 변수 보장
    // webpack으로 빌드된 경우, 번들 내에서 Utils와 Game이 전역에 등록되어야 함
    // 각 파일(Utils.js, Game.js)에서 window에 등록하는 코드가 있지만,
    // 실행 순서 문제를 방지하기 위해 약간의 대기 시간 추가
    await new Promise((resolve) => setTimeout(resolve, 100));

    // Utils와 Game이 로드될 때까지 기다림
    const scriptsLoaded = await waitForScripts();

    if (!scriptsLoaded) {
      // webpack 빌드 환경인 경우 추가 진단
      const isWebpackBuild = document.querySelector('script[src*="bundle.js"]');
      const errorMsg = "필수 클래스(Utils, Game)가 로드되지 않았습니다!";

      if (typeof window.simpleLog !== "undefined") {
        window.simpleLog(errorMsg, "error");
        if (isWebpackBuild) {
          window.simpleLog(
            "bundle.js가 로드되었지만 내부 모듈이 전역에 등록되지 않았습니다",
            "error"
          );
          window.simpleLog(
            "Utils.js와 Game.js의 window 등록 코드가 실행되지 않았을 수 있습니다",
            "error"
          );
        } else {
          window.simpleLog(
            "스크립트 파일들이 제대로 로드되지 않았을 수 있습니다",
            "error"
          );
        }
        window.simpleLog(
          "네트워크 연결을 확인하거나 페이지를 새로고침해주세요",
          "error"
        );
      }
      window.updateLoadingProgress(0, "오류가 발생했습니다. 새로고침해주세요.");
      return;
    }

    // Utils와 Game이 로드되었음을 확인 (window를 통해 접근)
    window.Utils.log("=== 게임 시작 ===");
    window.Utils.log("필수 클래스 로드 완료");

    // 로딩 시작
    window.Utils.log("로딩 진행 상태 업데이트 시작");
    window.updateLoadingProgress(10, "게임 시스템 초기화 중...");

    // 게임 인스턴스 생성
    window.Utils.log("Game 인스턴스 생성 시작...");
    game = new window.Game();
    window.Utils.log("Game 인스턴스 생성 완료");

    window.updateLoadingProgress(30, "3D 환경 설정 중...");

    // 게임 초기화 (비동기 작업)
    window.Utils.log("game.init() 호출 시작...");
    await game.init();
    window.Utils.log("game.init() 완료");

    window.updateLoadingProgress(90, "마무리 작업 중...");

    // 전역 게임 참조 (디버그용)
    window.Utils.log("전역 게임 참조 설정");
    window.game = game;

    window.updateLoadingProgress(100, "게임 준비 완료!");
    window.Utils.log("게임 준비 완료!");

    // 잠시 대기 후 로딩 화면 숨기기
    setTimeout(() => {
      window.Utils.log("로딩 화면 숨기기 시작");
      hideLoadingScreen();
      window.Utils.log("게임이 성공적으로 시작되었습니다!");
    }, 300);
  } catch (error) {
    // 에러 처리 시에도 Utils가 없을 수 있으므로 확인
    const errorMsg = "게임 초기화 중 오류 발생: " + error.message;
    const errorStack = "에러 스택: " + (error.stack || "스택 없음");

    if (typeof window.Utils !== "undefined") {
      window.Utils.log("=== 게임 초기화 중 오류 발생 ===", "error");
      window.Utils.log(errorMsg, "error");
      window.Utils.log(errorStack, "error");
    } else if (typeof window.simpleLog !== "undefined") {
      window.simpleLog("=== 게임 초기화 중 오류 발생 ===", "error");
      window.simpleLog(errorMsg, "error");
      window.simpleLog(errorStack, "error");
    }
    window.updateLoadingProgress(0, "오류가 발생했습니다. 새로고침해주세요.");
  }
}

// DOMContentLoaded와 window.onload 둘 다 처리
// DOMContentLoaded: DOM이 준비되면 즉시 대기 시작
window.addEventListener("DOMContentLoaded", () => {
  uiLog("DOMContentLoaded 이벤트 발생");

  // window.onload를 사용하여 모든 리소스(스크립트 포함)가 로드될 때까지 기다림
  if (document.readyState === "complete") {
    // 이미 모든 리소스가 로드된 경우 즉시 시작
    initializeGame();
  } else {
    // 모든 리소스 로드 대기
    window.addEventListener("load", () => {
      uiLog("window.onload 이벤트 발생 - 모든 리소스 로드 완료");
      initializeGame();
    });
  }
});

// 웹 페이지 언로드 시 정리
window.addEventListener("beforeunload", () => {
  if (game && game.gameLoop) {
    game.gameLoop.stop();
    if (typeof window.Utils !== "undefined") {
      window.Utils.log("게임 정리 완료");
    }
  }
});

// 탭 전환 시 게임 자동 일시정지/재개
document.addEventListener("visibilitychange", () => {
  if (!game) return;

  if (document.hidden) {
    // 탭이 숨겨지면 게임과 타이머 모두 일시정지
    if (game.gameLoop && game.gameLoop.getStatus().isRunning) {
      game.pause(true); // fromTab = true
      if (typeof window.Utils !== "undefined") {
        window.Utils.log("탭 전환으로 게임이 자동 일시정지되었습니다.");
      }
    }
  } else {
    // 탭이 다시 보이면 게임과 타이머 재개 (단, 수동 일시정지가 아닌 경우만)
    if (game.gameLoop && !game.gameLoop.getStatus().isRunning) {
      game.resume(true); // fromTab = true (내부에서 수동 일시정지 체크)
      if (typeof window.Utils !== "undefined") {
        window.Utils.log("탭 복귀로 게임 재개를 시도합니다.");
      }
    }
  }
});
